import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const PublicFooter = ({ center }) => (
  <footer className="bg-[#0B2545] text-white" data-testid="public-footer">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 sm:px-8 md:flex-row md:items-center md:justify-between">
      <div>
        <Logo light variant="footer" />
        <p className="mt-4 max-w-xs text-sm text-white/50">{center.tagline || "Atención integral, tecnología y confianza"}</p>
      </div>
      <div className="flex flex-wrap gap-x-8 gap-y-2 text-sm text-white/60">
        <a href="#servicios" className="hover:text-white">Servicios</a>
        <a href="#nosotros" className="hover:text-white">Nosotros</a>
        <a href="#contacto" className="hover:text-white">Contacto</a>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-5 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span>© {new Date().getFullYear()} {center.name || "Centro Médico IEMED"}. Todos los derechos reservados.</span>
        <Link to="/login" className="text-white/35 transition-colors hover:text-white/70" data-testid="footer-system-access-link">
          Acceso al sistema
        </Link>
      </div>
    </div>
  </footer>
);
